<template>
  <div>
    <ed-table
    :key="$root.$session.versao"
      strModel="Cadastro/Risco"
      :headers="arrayHeaders"
      :rows="arrayRows"
      :pagination="objPagination"
      :loading="loading"
      :filter="formFiltros"
      @register="onRegister"
      @edit="onEdit"
      @search="getFuncao"
    />
  </div>
</template>

<script>
import { EdTable } from "@/components/common/form";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { EdTable },
  beforeDestroy() {
    this.arrayHeaders = [];
    this.arrayRows = [];
    this.objPagination = null;
  },
  mounted() {
    this.getFuncao();
  },
  created() {},
  data() {
    return {
      loading: false,
      arrayHeaders: [
        {
          text: "Código eSocial",
          sortable: true,
          value: "strCodigoEsocial",
        },
        {
          text: "Nome",
          sortable: true,
          value: "strNome",
        },
        {
          text: "Categoria",
          sortable: true,
          value: "intParametroCategoriaId",
        },
      ],
      arrayRows: [],
      objPagination: null,
      formFiltros:{}
    };
  },
  methods: {
    onRegister() {
      this.$router.push({ name: "cadastro.risco.register" });
    },

    onEdit(data) {
      this.$router.push({
        name: "cadastro.risco.edit",
        params: { intId: data.intId },
      });
    },

    getFuncao() {
      this.loading = true;
      this.arrayRows = [];

      this.$root.$request.get("Cadastro/Risco", this.formFiltros).then((objResult) => {
        if (objResult.status == 200) {
          this.objPagination = objResult.result;
          this.loading = false;

          let arrayRows = [];

          objResult.result.data.forEach((objRisco) => {
            let item = {
              intId: objRisco.intId,
              strCodigoEsocial: objRisco.strCodigoEsocial,
              strNome: objRisco.strNome,
              intParametroCategoriaId: objRisco.categoria
                ? objRisco.categoria.strNome
                : "---",
              _item: objRisco,
            };

            arrayRows.push(item);
          });

          this.arrayRows = arrayRows;
        }
      });
    },
  },
};
</script>
